var _symbol, _use;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPythonLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 320,
    fill: "none",
    "aria-labelledby": "title"
  }, props), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "python_logo_svg__a",
    viewBox: "0 0 311 320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.639 313.288c84.502 0 153.004-68.502 153.004-153.004S240.141 7.28 155.639 7.28C71.138 7.28 2.636 75.782 2.636 160.284s68.502 153.004 153.003 153.004z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.64 315.38C69.983 315.38.544 245.941.544 160.284.544 74.627 69.983 5.188 155.64 5.188c85.656 0 155.095 69.44 155.095 155.096-.1 85.616-69.48 154.996-155.095 155.096zm0-306.008C72.293 9.372 4.728 76.938 4.728 160.284S72.293 311.196 155.64 311.196c83.346 0 150.911-67.566 150.911-150.912-.1-83.305-67.607-150.812-150.911-150.912z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.671 113.271h-24.824V61.266h-67.234c-15.014 0-27.188 12.167-27.196 27.18v24.825H83.593c-15.014.008-27.18 12.181-27.18 27.195v40.04c0 15.014 12.166 27.187 27.18 27.195h24.824v52.005h67.305c15.008-.008 27.173-12.173 27.181-27.181v-24.824h24.824a27.184 27.184 0 0027.181-27.195v-40.04a27.18 27.18 0 00-27.237-27.195z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.848 113.271v18.479a28.73 28.73 0 01-28.743 28.729h-36.944c-15.874 0-28.743 12.869-28.743 28.743v18.479",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.51 207.701h-4.184v-18.479c.023-17.02 13.815-30.812 30.835-30.835h36.944a26.677 26.677 0 0026.721-26.637v-18.479h4.183v18.479c-.023 17.018-13.817 30.806-30.835 30.821h-37.013c-14.712.016-26.636 11.939-26.651 26.651v18.479z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.307 95.671a8.424 8.424 0 100-16.848 8.424 8.424 0 000 16.848z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.307 97.763c-5.807 0-10.515-4.708-10.515-10.515 0-5.808 4.708-10.516 10.515-10.516 5.808 0 10.516 4.708 10.516 10.516-.008 5.804-4.711 10.508-10.516 10.515zm0-16.847a6.332 6.332 0 106.332 6.332 6.342 6.342 0 00-6.332-6.36v.028z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33 242.162a8.424 8.424 0 10-.001-16.847 8.424 8.424 0 00.001 16.847z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33 244.268a10.529 10.529 0 1110.515-10.529c0 5.809-4.705 10.521-10.515 10.529zm0-16.861a6.345 6.345 0 106.331 6.332 6.331 6.331 0 00-6.331-6.332z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.672 111.179h-22.663V14.95a2.092 2.092 0 10-4.184 0v44.266h-65.212c-16.175 0-29.287 13.112-29.287 29.286v22.733H83.594c-16.175 0-29.287 13.112-29.287 29.287v40.039a29.285 29.285 0 0029.287 29.287h22.732v96.076a2.092 2.092 0 004.184 0v-44.07h65.212c16.175 0 29.287-13.113 29.287-29.287v-22.733h22.732a29.283 29.283 0 0020.709-8.578 29.283 29.283 0 008.578-20.709v-40.081a29.291 29.291 0 00-8.602-20.734 29.292 29.292 0 00-20.754-8.553zm25.103 69.327c0 13.864-11.239 25.103-25.103 25.103h-60.457a2.092 2.092 0 100 4.184h33.61v22.732c0 13.864-11.239 25.103-25.103 25.103H110.51v-52.019H83.594c-13.864 0-25.103-11.239-25.103-25.103v-40.04c0-13.864 11.239-25.103 25.103-25.103h60.554a2.092 2.092 0 000-4.184H110.51V88.447c0-13.864 11.239-25.103 25.103-25.103h65.212v52.005h26.916c13.865 0 25.104 11.239 25.104 25.103l-.07 40.054z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.848 26.68c6.5 0 11.77-5.27 11.77-11.77 0-6.501-5.27-11.771-11.77-11.771-6.501 0-11.771 5.27-11.771 11.77 0 6.501 5.27 11.77 11.771 11.77z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.848 28.771a13.862 13.862 0 1113.848-13.862c-.045 7.632-6.217 13.809-13.848 13.862zm0-23.527a9.68 9.68 0 109.664 9.665 9.692 9.692 0 00-9.664-9.665z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.418 317.639c6.501 0 11.771-5.27 11.771-11.771 0-6.5-5.27-11.77-11.771-11.77-6.501 0-11.77 5.27-11.77 11.77 0 6.501 5.269 11.771 11.77 11.771z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.418 318.322a13.862 13.862 0 1113.862-13.848c-.008 7.65-6.212 13.848-13.862 13.848zm0-23.527a9.679 9.679 0 109.678 9.679c0-5.346-4.333-9.679-9.678-9.679z",
    fill: "#242424"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#python_logo_svg__a"
  })));
}

export default SvgPythonLogo;